import { createRoot } from "react-dom/client";
import "./styles/index.css";
import LogRocket from "logrocket";
import { LOGROCKET_URL } from "./config";
import App from "./App";

if (process.env.NODE_ENV === "production") {
  console.log("Version: " + process.env.REACT_APP_VERSION);
}

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

LOGROCKET_URL &&
  LogRocket.init(LOGROCKET_URL, {
    console: {
      /**
       * Allows console.error() to show up in Error tab in logrocket dashboard
       * By default log rocket only classifies uncaught exceptions as errors
       */
      shouldAggregateConsoleErrors: true,
    },
  });
